import http from "../http-common";
import IFlightRange from "../types/FlightRanges";

const getFlightRanges = (token) => {
  return http.get<Array<IFlightRange>>('/api/FlightRange',{
    headers:{
      Authorization: `Bearer ${token}`,
    }
  })
};

const FlightRangeService = {
  getFlightRanges,
};

export default FlightRangeService;